function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.SpreeSDK = e() : t.SpreeSDK = e();
}(window, function () {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        r.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 39);
  }([function (t, e, r) {
    t.exports = r(40);
  }, function (t, e) {
    function r(e) {
      return t.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, r(e);
    }

    t.exports = r;
  }, function (t, e) {
    t.exports = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e, r) {
    var n = r(15);

    t.exports = function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && n(t, e);
    };
  }, function (t, e, r) {
    var n = r(20),
        o = r(8);

    t.exports = function (t, e) {
      return !e || "object" !== n(e) && "function" != typeof e ? o(t) : e;
    };
  }, function (t, e) {
    function r(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    t.exports = function (t, e, n) {
      return e && r(t.prototype, e), n && r(t, n), t;
    };
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      r.d(e, "a", function () {
        return g;
      });

      var n = r(20),
          o = r.n(n),
          i = r(0),
          c = r.n(i),
          u = r(2),
          a = r.n(u),
          s = r(5),
          f = r.n(s),
          p = r(35),
          l = r.n(p),
          h = r(36),
          d = r(9),
          v = r(11),
          y = r(10),
          m = function m(t, e, r, n) {
        return new (r || (r = Promise))(function (o, i) {
          function c(t) {
            try {
              a(n.next(t));
            } catch (t) {
              i(t);
            }
          }

          function u(t) {
            try {
              a(n["throw"](t));
            } catch (t) {
              i(t);
            }
          }

          function a(t) {
            t.done ? o(t.value) : new r(function (e) {
              e(t.value);
            }).then(c, u);
          }

          a((n = n.apply(t, e || [])).next());
        });
      },
          g = function () {
        function e(r) {
          a()(this, e), this.host = r || t.env.SPREE_HOST || "http://localhost:3000/", this.axios = l.a.create({
            baseURL: this.host,
            headers: {
              "Content-Type": "application/json"
            },
            paramsSerializer: function paramsSerializer(t) {
              return h.stringify(t, {
                arrayFormat: "brackets"
              });
            }
          });
        }

        return f()(e, [{
          key: "spreeResponse",
          value: function value(t, e) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
            return m(this, void 0, void 0, c.a.mark(function o() {
              var i, u, a;
              return c.a.wrap(function (o) {
                for (;;) {
                  switch (o.prev = o.next) {
                    case 0:
                      return o.prev = 0, i = this.spreeOrderHeaders(r), u = {
                        url: e,
                        params: n,
                        method: t,
                        headers: i
                      }, o.next = 5, this.axios(u);

                    case 5:
                      return a = o.sent, o.abrupt("return", v.a.success(a.data));

                    case 9:
                      return o.prev = 9, o.t0 = o["catch"](0), o.abrupt("return", v.a.fail(this.processError(o.t0)));

                    case 12:
                    case "end":
                      return o.stop();
                  }
                }
              }, o, this, [[0, 9]]);
            }));
          }
        }, {
          key: "classifyError",
          value: function value(t) {
            var e = t.response.data,
                r = e.error,
                n = e.errors;
            return "string" == typeof r ? "object" === o()(n) ? y.a.FULL : y.a.BASIC : y.a.LIMITED;
          }
        }, {
          key: "processError",
          value: function value(t) {
            return t.response ? this.processSpreeError(t) : t.request ? new d.NoResponseError() : new d.MisconfigurationError(t.message);
          }
        }, {
          key: "processSpreeError",
          value: function value(t) {
            var e = t.response.data,
                r = e.error,
                n = e.errors,
                o = this.classifyError(t);
            return o === y.a.FULL ? new d.ExpandedSpreeError(t.response, r, n) : o === y.a.BASIC ? new d.BasicSpreeError(t.response, r) : new d.SpreeError(t.response);
          }
        }, {
          key: "spreeOrderHeaders",
          value: function value(t) {
            var e = {};
            return t.orderToken && (e["X-Spree-Order-Token"] = t.orderToken), t.bearerToken && (e.Authorization = "Bearer ".concat(t.bearerToken)), e;
          }
        }]), e;
      }();
    }).call(this, r(21));
  }, function (t, e, r) {
    "use strict";

    var n = r(22),
        o = r(43),
        i = Object.prototype.toString;

    function c(t) {
      return "[object Array]" === i.call(t);
    }

    function u(t) {
      return null !== t && "object" == _typeof(t);
    }

    function a(t) {
      return "[object Function]" === i.call(t);
    }

    function s(t, e) {
      if (null != t) if ("object" != _typeof(t) && (t = [t]), c(t)) for (var r = 0, n = t.length; r < n; r++) {
        e.call(null, t[r], r, t);
      } else for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && e.call(null, t[o], o, t);
      }
    }

    t.exports = {
      isArray: c,
      isArrayBuffer: function isArrayBuffer(t) {
        return "[object ArrayBuffer]" === i.call(t);
      },
      isBuffer: o,
      isFormData: function isFormData(t) {
        return "undefined" != typeof FormData && t instanceof FormData;
      },
      isArrayBufferView: function isArrayBufferView(t) {
        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && t.buffer instanceof ArrayBuffer;
      },
      isString: function isString(t) {
        return "string" == typeof t;
      },
      isNumber: function isNumber(t) {
        return "number" == typeof t;
      },
      isObject: u,
      isUndefined: function isUndefined(t) {
        return void 0 === t;
      },
      isDate: function isDate(t) {
        return "[object Date]" === i.call(t);
      },
      isFile: function isFile(t) {
        return "[object File]" === i.call(t);
      },
      isBlob: function isBlob(t) {
        return "[object Blob]" === i.call(t);
      },
      isFunction: a,
      isStream: function isStream(t) {
        return u(t) && a(t.pipe);
      },
      isURLSearchParams: function isURLSearchParams(t) {
        return "undefined" != typeof URLSearchParams && t instanceof URLSearchParams;
      },
      isStandardBrowserEnv: function isStandardBrowserEnv() {
        return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
      },
      forEach: s,
      merge: function t() {
        var e = {};

        function r(r, n) {
          "object" == _typeof(e[n]) && "object" == _typeof(r) ? e[n] = t(e[n], r) : e[n] = r;
        }

        for (var n = 0, o = arguments.length; n < o; n++) {
          s(arguments[n], r);
        }

        return e;
      },
      deepMerge: function t() {
        var e = {};

        function r(r, n) {
          "object" == _typeof(e[n]) && "object" == _typeof(r) ? e[n] = t(e[n], r) : e[n] = "object" == _typeof(r) ? t({}, r) : r;
        }

        for (var n = 0, o = arguments.length; n < o; n++) {
          s(arguments[n], r);
        }

        return e;
      },
      extend: function extend(t, e, r) {
        return s(e, function (e, o) {
          t[o] = r && "function" == typeof e ? n(e, r) : e;
        }), t;
      },
      trim: function trim(t) {
        return t.replace(/^\s*/, "").replace(/\s*$/, "");
      }
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    };
  }, function (t, e, r) {
    "use strict";

    r.r(e);
    var n = r(2),
        o = r.n(n),
        i = r(8),
        c = r.n(i),
        u = r(3),
        a = r.n(u),
        s = r(4),
        f = r.n(s),
        p = r(1),
        l = r.n(p),
        h = r(37);

    function d() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var v = function (t) {
      a()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = l()(e);

        if (d()) {
          var n = l()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return f()(this, t);
      });

      function n(t) {
        var e;
        return o()(this, n), e = r.call(this, t), Object.setPrototypeOf(c()(e), n.prototype), e;
      }

      return n;
    }(r.n(h)()(Error));

    function y() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var m = function (t) {
      a()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = l()(e);

        if (y()) {
          var n = l()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return f()(this, t);
      });

      function n(t) {
        var e;
        o()(this, n), e = r.call(this, "Spree returned a HTTP ".concat(t.status, " error code")), Object.setPrototypeOf(c()(e), n.prototype), e.name = "SpreeError";
        var i = Object.assign({}, t);
        return Object.defineProperties(i, {
          config: {
            enumerable: !1
          },
          data: {
            enumerable: !1
          },
          headers: {
            enumerable: !1
          },
          request: {
            enumerable: !1
          }
        }), e.serverResponse = i, e;
      }

      return n;
    }(v);

    function g() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var x = function (t) {
      a()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = l()(e);

        if (g()) {
          var n = l()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return f()(this, t);
      });

      function n(t, e) {
        var i;
        return o()(this, n), i = r.call(this, t), Object.setPrototypeOf(c()(i), n.prototype), i.name = "BasicSpreeError", i.summary = e, i;
      }

      return n;
    }(m),
        w = r(5),
        b = r.n(w),
        k = r(38),
        R = r.n(k);

    function P() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var O = function (t) {
      a()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = l()(e);

        if (P()) {
          var n = l()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return f()(this, t);
      });

      function n(t, e, i) {
        var u;
        return o()(this, n), u = r.call(this, t, e), Object.setPrototypeOf(c()(u), n.prototype), u.name = "ExpandedSpreeError", u.errors = Object.keys(i).reduce(function (t, e) {
          for (var r = e.split("."), n = r.shift(), o = t; n;) {
            o[n] || (0 === r.length ? o[n] = i[e] : o[n] = {}), o = o[n], n = r.shift();
          }

          return t;
        }, {}), u;
      }

      return b()(n, [{
        key: "getErrors",
        value: function value(t) {
          return R()(this.errors, t, null);
        }
      }]), n;
    }(x);

    function S() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var j = function (t) {
      a()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = l()(e);

        if (S()) {
          var n = l()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return f()(this, t);
      });

      function n(t) {
        var e;
        return o()(this, n), e = r.call(this, "Incorrect request setup: ".concat(t)), Object.setPrototypeOf(c()(e), n.prototype), e.name = "MisconfigurationError", e;
      }

      return n;
    }(v);

    function _() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var E = function (t) {
      a()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = l()(e);

        if (_()) {
          var n = l()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return f()(this, t);
      });

      function n() {
        var t;
        return o()(this, n), t = r.call(this, "No response received from Spree"), Object.setPrototypeOf(c()(t), n.prototype), t.name = "NoResponseError", t;
      }

      return n;
    }(v);

    r.d(e, "BasicSpreeError", function () {
      return x;
    }), r.d(e, "ExpandedSpreeError", function () {
      return O;
    }), r.d(e, "MisconfigurationError", function () {
      return j;
    }), r.d(e, "NoResponseError", function () {
      return E;
    }), r.d(e, "SpreeError", function () {
      return m;
    }), r.d(e, "SpreeSDKError", function () {
      return v;
    });
  }, function (t, e, r) {
    "use strict";

    var n;
    r.d(e, "a", function () {
      return n;
    }), function (t) {
      t[t.BASIC = 0] = "BASIC", t[t.FULL = 1] = "FULL", t[t.LIMITED = 2] = "LIMITED";
    }(n || (n = {}));
  }, function (t, e, r) {
    "use strict";

    e.a = {
      success: function success(t) {
        return function (t) {
          return {
            isSuccess: function isSuccess() {
              return !0;
            },
            isFail: function isFail() {
              return !1;
            },
            success: function success() {
              return t;
            },
            fail: function fail() {
              throw new Error("Cannot call fail() on success.");
            }
          };
        }(t);
      },
      fail: function fail(t) {
        return function (t) {
          return {
            isSuccess: function isSuccess() {
              return !1;
            },
            isFail: function isFail() {
              return !0;
            },
            success: function success() {
              throw new Error("Cannot call success() on fail.");
            },
            fail: function fail() {
              return t;
            }
          };
        }(t);
      }
    };
  }, function (t, e, r) {
    var n = r(33)(Object, "create");
    t.exports = n;
  }, function (t, e, r) {
    var n = r(90);

    t.exports = function (t, e) {
      for (var r = t.length; r--;) {
        if (n(t[r][0], e)) return r;
      }

      return -1;
    };
  }, function (t, e, r) {
    var n = r(96);

    t.exports = function (t, e) {
      var r = t.__data__;
      return n(e) ? r["string" == typeof e ? "string" : "hash"] : r.map;
    };
  }, function (t, e) {
    function r(e, n) {
      return t.exports = r = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, r(e, n);
    }

    t.exports = r;
  }, function (t, e) {
    var r = Array.isArray;
    t.exports = r;
  }, function (t, e, r) {
    var n = r(32),
        o = r(69);

    t.exports = function (t) {
      return "symbol" == _typeof(t) || o(t) && "[object Symbol]" == n(t);
    };
  }, function (t, e, r) {
    var n = r(19).Symbol;
    t.exports = n;
  }, function (t, e, r) {
    var n = r(65),
        o = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
        i = n || o || Function("return this")();
    t.exports = i;
  }, function (t, e) {
    function r(t) {
      return (r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function n(e) {
      return "function" == typeof Symbol && "symbol" === r(Symbol.iterator) ? t.exports = n = function n(t) {
        return r(t);
      } : t.exports = n = function n(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : r(t);
      }, n(e);
    }

    t.exports = n;
  }, function (t, e) {
    var r,
        n,
        o = t.exports = {};

    function i() {
      throw new Error("setTimeout has not been defined");
    }

    function c() {
      throw new Error("clearTimeout has not been defined");
    }

    function u(t) {
      if (r === setTimeout) return setTimeout(t, 0);
      if ((r === i || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);

      try {
        return r(t, 0);
      } catch (e) {
        try {
          return r.call(null, t, 0);
        } catch (e) {
          return r.call(this, t, 0);
        }
      }
    }

    !function () {
      try {
        r = "function" == typeof setTimeout ? setTimeout : i;
      } catch (t) {
        r = i;
      }

      try {
        n = "function" == typeof clearTimeout ? clearTimeout : c;
      } catch (t) {
        n = c;
      }
    }();
    var a,
        s = [],
        f = !1,
        p = -1;

    function l() {
      f && a && (f = !1, a.length ? s = a.concat(s) : p = -1, s.length && h());
    }

    function h() {
      if (!f) {
        var t = u(l);
        f = !0;

        for (var e = s.length; e;) {
          for (a = s, s = []; ++p < e;) {
            a && a[p].run();
          }

          p = -1, e = s.length;
        }

        a = null, f = !1, function (t) {
          if (n === clearTimeout) return clearTimeout(t);
          if ((n === c || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);

          try {
            n(t);
          } catch (e) {
            try {
              return n.call(null, t);
            } catch (e) {
              return n.call(this, t);
            }
          }
        }(t);
      }
    }

    function d(t, e) {
      this.fun = t, this.array = e;
    }

    function v() {}

    o.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
        e[r - 1] = arguments[r];
      }
      s.push(new d(t, e)), 1 !== s.length || f || u(h);
    }, d.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = v, o.addListener = v, o.once = v, o.off = v, o.removeListener = v, o.removeAllListeners = v, o.emit = v, o.prependListener = v, o.prependOnceListener = v, o.listeners = function (t) {
      return [];
    }, o.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t, e) {
      return function () {
        for (var r = new Array(arguments.length), n = 0; n < r.length; n++) {
          r[n] = arguments[n];
        }

        return t.apply(e, r);
      };
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7);

    function o(t) {
      return encodeURIComponent(t).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }

    t.exports = function (t, e, r) {
      if (!e) return t;
      var i;
      if (r) i = r(e);else if (n.isURLSearchParams(e)) i = e.toString();else {
        var c = [];
        n.forEach(e, function (t, e) {
          null != t && (n.isArray(t) ? e += "[]" : t = [t], n.forEach(t, function (t) {
            n.isDate(t) ? t = t.toISOString() : n.isObject(t) && (t = JSON.stringify(t)), c.push(o(e) + "=" + o(t));
          }));
        }), i = c.join("&");
      }

      if (i) {
        var u = t.indexOf("#");
        -1 !== u && (t = t.slice(0, u)), t += (-1 === t.indexOf("?") ? "?" : "&") + i;
      }

      return t;
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t) {
      return !(!t || !t.__CANCEL__);
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      var n = r(7),
          o = r(48),
          i = {
        "Content-Type": "application/x-www-form-urlencoded"
      };

      function c(t, e) {
        !n.isUndefined(t) && n.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
      }

      var u,
          a = {
        adapter: ((void 0 !== e && "[object process]" === Object.prototype.toString.call(e) || "undefined" != typeof XMLHttpRequest) && (u = r(26)), u),
        transformRequest: [function (t, e) {
          return o(e, "Accept"), o(e, "Content-Type"), n.isFormData(t) || n.isArrayBuffer(t) || n.isBuffer(t) || n.isStream(t) || n.isFile(t) || n.isBlob(t) ? t : n.isArrayBufferView(t) ? t.buffer : n.isURLSearchParams(t) ? (c(e, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : n.isObject(t) ? (c(e, "application/json;charset=utf-8"), JSON.stringify(t)) : t;
        }],
        transformResponse: [function (t) {
          if ("string" == typeof t) try {
            t = JSON.parse(t);
          } catch (t) {}
          return t;
        }],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        validateStatus: function validateStatus(t) {
          return t >= 200 && t < 300;
        }
      };
      a.headers = {
        common: {
          Accept: "application/json, text/plain, */*"
        }
      }, n.forEach(["delete", "get", "head"], function (t) {
        a.headers[t] = {};
      }), n.forEach(["post", "put", "patch"], function (t) {
        a.headers[t] = n.merge(i);
      }), t.exports = a;
    }).call(this, r(21));
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        o = r(49),
        i = r(23),
        c = r(51),
        u = r(52),
        a = r(27);

    t.exports = function (t) {
      return new Promise(function (e, s) {
        var f = t.data,
            p = t.headers;
        n.isFormData(f) && delete p["Content-Type"];
        var l = new XMLHttpRequest();

        if (t.auth) {
          var h = t.auth.username || "",
              d = t.auth.password || "";
          p.Authorization = "Basic " + btoa(h + ":" + d);
        }

        if (l.open(t.method.toUpperCase(), i(t.url, t.params, t.paramsSerializer), !0), l.timeout = t.timeout, l.onreadystatechange = function () {
          if (l && 4 === l.readyState && (0 !== l.status || l.responseURL && 0 === l.responseURL.indexOf("file:"))) {
            var r = "getAllResponseHeaders" in l ? c(l.getAllResponseHeaders()) : null,
                n = {
              data: t.responseType && "text" !== t.responseType ? l.response : l.responseText,
              status: l.status,
              statusText: l.statusText,
              headers: r,
              config: t,
              request: l
            };
            o(e, s, n), l = null;
          }
        }, l.onabort = function () {
          l && (s(a("Request aborted", t, "ECONNABORTED", l)), l = null);
        }, l.onerror = function () {
          s(a("Network Error", t, null, l)), l = null;
        }, l.ontimeout = function () {
          s(a("timeout of " + t.timeout + "ms exceeded", t, "ECONNABORTED", l)), l = null;
        }, n.isStandardBrowserEnv()) {
          var v = r(53),
              y = (t.withCredentials || u(t.url)) && t.xsrfCookieName ? v.read(t.xsrfCookieName) : void 0;
          y && (p[t.xsrfHeaderName] = y);
        }

        if ("setRequestHeader" in l && n.forEach(p, function (t, e) {
          void 0 === f && "content-type" === e.toLowerCase() ? delete p[e] : l.setRequestHeader(e, t);
        }), t.withCredentials && (l.withCredentials = !0), t.responseType) try {
          l.responseType = t.responseType;
        } catch (e) {
          if ("json" !== t.responseType) throw e;
        }
        "function" == typeof t.onDownloadProgress && l.addEventListener("progress", t.onDownloadProgress), "function" == typeof t.onUploadProgress && l.upload && l.upload.addEventListener("progress", t.onUploadProgress), t.cancelToken && t.cancelToken.promise.then(function (t) {
          l && (l.abort(), s(t), l = null);
        }), void 0 === f && (f = null), l.send(f);
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(50);

    t.exports = function (t, e, r, o, i) {
      var c = new Error(t);
      return n(c, e, r, o, i);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7);

    t.exports = function (t, e) {
      e = e || {};
      var r = {};
      return n.forEach(["url", "method", "params", "data"], function (t) {
        void 0 !== e[t] && (r[t] = e[t]);
      }), n.forEach(["headers", "auth", "proxy"], function (o) {
        n.isObject(e[o]) ? r[o] = n.deepMerge(t[o], e[o]) : void 0 !== e[o] ? r[o] = e[o] : n.isObject(t[o]) ? r[o] = n.deepMerge(t[o]) : void 0 !== t[o] && (r[o] = t[o]);
      }), n.forEach(["baseURL", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "maxContentLength", "validateStatus", "maxRedirects", "httpAgent", "httpsAgent", "cancelToken", "socketPath"], function (n) {
        void 0 !== e[n] ? r[n] = e[n] : void 0 !== t[n] && (r[n] = t[n]);
      }), r;
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      this.message = t;
    }

    n.prototype.toString = function () {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }, n.prototype.__CANCEL__ = !0, t.exports = n;
  }, function (t, e, r) {
    "use strict";

    var n = Object.prototype.hasOwnProperty,
        o = function () {
      for (var t = [], e = 0; e < 256; ++e) {
        t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
      }

      return t;
    }(),
        i = function i(t, e) {
      for (var r = e && e.plainObjects ? Object.create(null) : {}, n = 0; n < t.length; ++n) {
        void 0 !== t[n] && (r[n] = t[n]);
      }

      return r;
    };

    t.exports = {
      arrayToObject: i,
      assign: function assign(t, e) {
        return Object.keys(e).reduce(function (t, r) {
          return t[r] = e[r], t;
        }, t);
      },
      combine: function combine(t, e) {
        return [].concat(t, e);
      },
      compact: function compact(t) {
        for (var e = [{
          obj: {
            o: t
          },
          prop: "o"
        }], r = [], n = 0; n < e.length; ++n) {
          for (var o = e[n], i = o.obj[o.prop], c = Object.keys(i), u = 0; u < c.length; ++u) {
            var a = c[u],
                s = i[a];
            "object" == _typeof(s) && null !== s && -1 === r.indexOf(s) && (e.push({
              obj: i,
              prop: a
            }), r.push(s));
          }
        }

        return function (t) {
          for (; t.length > 1;) {
            var e = t.pop(),
                r = e.obj[e.prop];

            if (Array.isArray(r)) {
              for (var n = [], o = 0; o < r.length; ++o) {
                void 0 !== r[o] && n.push(r[o]);
              }

              e.obj[e.prop] = n;
            }
          }
        }(e), t;
      },
      decode: function decode(t, e, r) {
        var n = t.replace(/\+/g, " ");
        if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);

        try {
          return decodeURIComponent(n);
        } catch (t) {
          return n;
        }
      },
      encode: function encode(t, e, r) {
        if (0 === t.length) return t;
        var n = "string" == typeof t ? t : String(t);
        if ("iso-8859-1" === r) return escape(n).replace(/%u[0-9a-f]{4}/gi, function (t) {
          return "%26%23" + parseInt(t.slice(2), 16) + "%3B";
        });

        for (var i = "", c = 0; c < n.length; ++c) {
          var u = n.charCodeAt(c);
          45 === u || 46 === u || 95 === u || 126 === u || u >= 48 && u <= 57 || u >= 65 && u <= 90 || u >= 97 && u <= 122 ? i += n.charAt(c) : u < 128 ? i += o[u] : u < 2048 ? i += o[192 | u >> 6] + o[128 | 63 & u] : u < 55296 || u >= 57344 ? i += o[224 | u >> 12] + o[128 | u >> 6 & 63] + o[128 | 63 & u] : (c += 1, u = 65536 + ((1023 & u) << 10 | 1023 & n.charCodeAt(c)), i += o[240 | u >> 18] + o[128 | u >> 12 & 63] + o[128 | u >> 6 & 63] + o[128 | 63 & u]);
        }

        return i;
      },
      isBuffer: function isBuffer(t) {
        return null != t && !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
      },
      isRegExp: function isRegExp(t) {
        return "[object RegExp]" === Object.prototype.toString.call(t);
      },
      merge: function t(e, r, o) {
        if (!r) return e;

        if ("object" != _typeof(r)) {
          if (Array.isArray(e)) e.push(r);else {
            if ("object" != _typeof(e)) return [e, r];
            (o && (o.plainObjects || o.allowPrototypes) || !n.call(Object.prototype, r)) && (e[r] = !0);
          }
          return e;
        }

        if ("object" != _typeof(e)) return [e].concat(r);
        var c = e;
        return Array.isArray(e) && !Array.isArray(r) && (c = i(e, o)), Array.isArray(e) && Array.isArray(r) ? (r.forEach(function (r, i) {
          n.call(e, i) ? e[i] && "object" == _typeof(e[i]) ? e[i] = t(e[i], r, o) : e.push(r) : e[i] = r;
        }), e) : Object.keys(r).reduce(function (e, i) {
          var c = r[i];
          return n.call(e, i) ? e[i] = t(e[i], c, o) : e[i] = c, e;
        }, c);
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = String.prototype.replace,
        o = /%20/g;
    t.exports = {
      "default": "RFC3986",
      formatters: {
        RFC1738: function RFC1738(t) {
          return n.call(t, o, "+");
        },
        RFC3986: function RFC3986(t) {
          return t;
        }
      },
      RFC1738: "RFC1738",
      RFC3986: "RFC3986"
    };
  }, function (t, e, r) {
    var n = r(18),
        o = r(67),
        i = r(68),
        c = n ? n.toStringTag : void 0;

    t.exports = function (t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : c && c in Object(t) ? o(t) : i(t);
    };
  }, function (t, e, r) {
    var n = r(77),
        o = r(82);

    t.exports = function (t, e) {
      var r = o(t, e);
      return n(r) ? r : void 0;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = _typeof(t);

      return null != t && ("object" == e || "function" == e);
    };
  }, function (t, e, r) {
    t.exports = r(42);
  }, function (t, e, r) {
    "use strict";

    var n = r(58),
        o = r(59),
        i = r(31);
    t.exports = {
      formats: i,
      parse: o,
      stringify: n
    };
  }, function (t, e, r) {
    var n = r(1),
        o = r(15),
        i = r(60),
        c = r(61);

    function u(e) {
      var r = "function" == typeof Map ? new Map() : void 0;
      return t.exports = u = function u(t) {
        if (null === t || !i(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== r) {
          if (r.has(t)) return r.get(t);
          r.set(t, e);
        }

        function e() {
          return c(t, arguments, n(this).constructor);
        }

        return e.prototype = Object.create(t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), o(e, t);
      }, u(e);
    }

    t.exports = u;
  }, function (t, e, r) {
    var n = r(62);

    t.exports = function (t, e, r) {
      var o = null == t ? void 0 : n(t, e);
      return void 0 === o ? r : o;
    };
  }, function (t, e, r) {
    t.exports = r(104);
  }, function (t, e, r) {
    var n = function () {
      return this || "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self;
    }() || Function("return this")(),
        o = n.regeneratorRuntime && Object.getOwnPropertyNames(n).indexOf("regeneratorRuntime") >= 0,
        i = o && n.regeneratorRuntime;

    if (n.regeneratorRuntime = void 0, t.exports = r(41), o) n.regeneratorRuntime = i;else try {
      delete n.regeneratorRuntime;
    } catch (t) {
      n.regeneratorRuntime = void 0;
    }
  }, function (t, e) {
    !function (e) {
      "use strict";

      var r = Object.prototype,
          n = r.hasOwnProperty,
          o = "function" == typeof Symbol ? Symbol : {},
          i = o.iterator || "@@iterator",
          c = o.asyncIterator || "@@asyncIterator",
          u = o.toStringTag || "@@toStringTag",
          a = "object" == _typeof(t),
          s = e.regeneratorRuntime;

      if (s) a && (t.exports = s);else {
        (s = e.regeneratorRuntime = a ? t.exports : {}).wrap = v;
        var f = {},
            p = {};

        p[i] = function () {
          return this;
        };

        var l = Object.getPrototypeOf,
            h = l && l(l(S([])));
        h && h !== r && n.call(h, i) && (p = h);
        var d = x.prototype = m.prototype = Object.create(p);
        g.prototype = d.constructor = x, x.constructor = g, x[u] = g.displayName = "GeneratorFunction", s.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === g || "GeneratorFunction" === (e.displayName || e.name));
        }, s.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, x) : (t.__proto__ = x, u in t || (t[u] = "GeneratorFunction")), t.prototype = Object.create(d), t;
        }, s.awrap = function (t) {
          return {
            __await: t
          };
        }, w(b.prototype), b.prototype[c] = function () {
          return this;
        }, s.AsyncIterator = b, s.async = function (t, e, r, n) {
          var o = new b(v(t, e, r, n));
          return s.isGeneratorFunction(e) ? o : o.next().then(function (t) {
            return t.done ? t.value : o.next();
          });
        }, w(d), d[u] = "Generator", d[i] = function () {
          return this;
        }, d.toString = function () {
          return "[object Generator]";
        }, s.keys = function (t) {
          var e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.reverse(), function r() {
            for (; e.length;) {
              var n = e.pop();
              if (n in t) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, s.values = S, O.prototype = {
          constructor: O,
          reset: function reset(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(P), !t) for (var e in this) {
              "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(t) {
            if (this.done) throw t;
            var e = this;

            function r(r, n) {
              return c.type = "throw", c.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  c = i.completion;
              if ("root" === i.tryLoc) return r("end");

              if (i.tryLoc <= this.prev) {
                var u = n.call(i, "catchLoc"),
                    a = n.call(i, "finallyLoc");

                if (u && a) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                } else if (u) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                } else {
                  if (!a) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var o = this.tryEntries[r];

              if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }

            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var c = i ? i.completion : {};
            return c.type = t, c.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, f) : this.complete(c);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), f;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), P(r), f;
            }
          },
          "catch": function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];

              if (r.tryLoc === t) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  P(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(t, e, r) {
            return this.delegate = {
              iterator: S(t),
              resultName: e,
              nextLoc: r
            }, "next" === this.method && (this.arg = void 0), f;
          }
        };
      }

      function v(t, e, r, n) {
        var o = e && e.prototype instanceof m ? e : m,
            i = Object.create(o.prototype),
            c = new O(n || []);
        return i._invoke = function (t, e, r) {
          var n = "suspendedStart";
          return function (o, i) {
            if ("executing" === n) throw new Error("Generator is already running");

            if ("completed" === n) {
              if ("throw" === o) throw i;
              return j();
            }

            for (r.method = o, r.arg = i;;) {
              var c = r.delegate;

              if (c) {
                var u = k(c, r);

                if (u) {
                  if (u === f) continue;
                  return u;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw n = "completed", r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var a = y(t, e, r);

              if ("normal" === a.type) {
                if (n = r.done ? "completed" : "suspendedYield", a.arg === f) continue;
                return {
                  value: a.arg,
                  done: r.done
                };
              }

              "throw" === a.type && (n = "completed", r.method = "throw", r.arg = a.arg);
            }
          };
        }(t, r, c), i;
      }

      function y(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      function m() {}

      function g() {}

      function x() {}

      function w(t) {
        ["next", "throw", "return"].forEach(function (e) {
          t[e] = function (t) {
            return this._invoke(e, t);
          };
        });
      }

      function b(t) {
        var e;

        this._invoke = function (r, o) {
          function i() {
            return new Promise(function (e, i) {
              !function e(r, o, i, c) {
                var u = y(t[r], t, o);

                if ("throw" !== u.type) {
                  var a = u.arg,
                      s = a.value;
                  return s && "object" == _typeof(s) && n.call(s, "__await") ? Promise.resolve(s.__await).then(function (t) {
                    e("next", t, i, c);
                  }, function (t) {
                    e("throw", t, i, c);
                  }) : Promise.resolve(s).then(function (t) {
                    a.value = t, i(a);
                  }, function (t) {
                    return e("throw", t, i, c);
                  });
                }

                c(u.arg);
              }(r, o, e, i);
            });
          }

          return e = e ? e.then(i, i) : i();
        };
      }

      function k(t, e) {
        var r = t.iterator[e.method];

        if (void 0 === r) {
          if (e.delegate = null, "throw" === e.method) {
            if (t.iterator["return"] && (e.method = "return", e.arg = void 0, k(t, e), "throw" === e.method)) return f;
            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return f;
        }

        var n = y(r, t.iterator, e.arg);
        if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, f;
        var o = n.arg;
        return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, f) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
      }

      function R(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function P(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function O(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(R, this), this.reset(!0);
      }

      function S(t) {
        if (t) {
          var e = t[i];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var r = -1,
                o = function e() {
              for (; ++r < t.length;) {
                if (n.call(t, r)) return e.value = t[r], e.done = !1, e;
              }

              return e.value = void 0, e.done = !0, e;
            };

            return o.next = o;
          }
        }

        return {
          next: j
        };
      }

      function j() {
        return {
          value: void 0,
          done: !0
        };
      }
    }(function () {
      return this || "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self;
    }() || Function("return this")());
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        o = r(22),
        i = r(44),
        c = r(28);

    function u(t) {
      var e = new i(t),
          r = o(i.prototype.request, e);
      return n.extend(r, i.prototype, e), n.extend(r, e), r;
    }

    var a = u(r(25));
    a.Axios = i, a.create = function (t) {
      return u(c(a.defaults, t));
    }, a.Cancel = r(29), a.CancelToken = r(56), a.isCancel = r(24), a.all = function (t) {
      return Promise.all(t);
    }, a.spread = r(57), t.exports = a, t.exports["default"] = a;
  }, function (t, e) {
    /*!
     * Determine if an object is a Buffer
     *
     * @author   Feross Aboukhadijeh <https://feross.org>
     * @license  MIT
     */
    t.exports = function (t) {
      return null != t && null != t.constructor && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        o = r(23),
        i = r(45),
        c = r(46),
        u = r(28);

    function a(t) {
      this.defaults = t, this.interceptors = {
        request: new i(),
        response: new i()
      };
    }

    a.prototype.request = function (t) {
      "string" == typeof t ? (t = arguments[1] || {}).url = arguments[0] : t = t || {}, (t = u(this.defaults, t)).method = t.method ? t.method.toLowerCase() : "get";
      var e = [c, void 0],
          r = Promise.resolve(t);

      for (this.interceptors.request.forEach(function (t) {
        e.unshift(t.fulfilled, t.rejected);
      }), this.interceptors.response.forEach(function (t) {
        e.push(t.fulfilled, t.rejected);
      }); e.length;) {
        r = r.then(e.shift(), e.shift());
      }

      return r;
    }, a.prototype.getUri = function (t) {
      return t = u(this.defaults, t), o(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
    }, n.forEach(["delete", "get", "head", "options"], function (t) {
      a.prototype[t] = function (e, r) {
        return this.request(n.merge(r || {}, {
          method: t,
          url: e
        }));
      };
    }), n.forEach(["post", "put", "patch"], function (t) {
      a.prototype[t] = function (e, r, o) {
        return this.request(n.merge(o || {}, {
          method: t,
          url: e,
          data: r
        }));
      };
    }), t.exports = a;
  }, function (t, e, r) {
    "use strict";

    var n = r(7);

    function o() {
      this.handlers = [];
    }

    o.prototype.use = function (t, e) {
      return this.handlers.push({
        fulfilled: t,
        rejected: e
      }), this.handlers.length - 1;
    }, o.prototype.eject = function (t) {
      this.handlers[t] && (this.handlers[t] = null);
    }, o.prototype.forEach = function (t) {
      n.forEach(this.handlers, function (e) {
        null !== e && t(e);
      });
    }, t.exports = o;
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        o = r(47),
        i = r(24),
        c = r(25),
        u = r(54),
        a = r(55);

    function s(t) {
      t.cancelToken && t.cancelToken.throwIfRequested();
    }

    t.exports = function (t) {
      return s(t), t.baseURL && !u(t.url) && (t.url = a(t.baseURL, t.url)), t.headers = t.headers || {}, t.data = o(t.data, t.headers, t.transformRequest), t.headers = n.merge(t.headers.common || {}, t.headers[t.method] || {}, t.headers || {}), n.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (e) {
        delete t.headers[e];
      }), (t.adapter || c.adapter)(t).then(function (e) {
        return s(t), e.data = o(e.data, e.headers, t.transformResponse), e;
      }, function (e) {
        return i(e) || (s(t), e && e.response && (e.response.data = o(e.response.data, e.response.headers, t.transformResponse))), Promise.reject(e);
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7);

    t.exports = function (t, e, r) {
      return n.forEach(r, function (r) {
        t = r(t, e);
      }), t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7);

    t.exports = function (t, e) {
      n.forEach(t, function (r, n) {
        n !== e && n.toUpperCase() === e.toUpperCase() && (t[e] = r, delete t[n]);
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(27);

    t.exports = function (t, e, r) {
      var o = r.config.validateStatus;
      !o || o(r.status) ? t(r) : e(n("Request failed with status code " + r.status, r.config, null, r.request, r));
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t, e, r, n, o) {
      return t.config = e, r && (t.code = r), t.request = n, t.response = o, t.isAxiosError = !0, t.toJSON = function () {
        return {
          message: this.message,
          name: this.name,
          description: this.description,
          number: this.number,
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          config: this.config,
          code: this.code
        };
      }, t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        o = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

    t.exports = function (t) {
      var e,
          r,
          i,
          c = {};
      return t ? (n.forEach(t.split("\n"), function (t) {
        if (i = t.indexOf(":"), e = n.trim(t.substr(0, i)).toLowerCase(), r = n.trim(t.substr(i + 1)), e) {
          if (c[e] && o.indexOf(e) >= 0) return;
          c[e] = "set-cookie" === e ? (c[e] ? c[e] : []).concat([r]) : c[e] ? c[e] + ", " + r : r;
        }
      }), c) : c;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7);
    t.exports = n.isStandardBrowserEnv() ? function () {
      var t,
          e = /(msie|trident)/i.test(navigator.userAgent),
          r = document.createElement("a");

      function o(t) {
        var n = t;
        return e && (r.setAttribute("href", n), n = r.href), r.setAttribute("href", n), {
          href: r.href,
          protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
          host: r.host,
          search: r.search ? r.search.replace(/^\?/, "") : "",
          hash: r.hash ? r.hash.replace(/^#/, "") : "",
          hostname: r.hostname,
          port: r.port,
          pathname: "/" === r.pathname.charAt(0) ? r.pathname : "/" + r.pathname
        };
      }

      return t = o(window.location.href), function (e) {
        var r = n.isString(e) ? o(e) : e;
        return r.protocol === t.protocol && r.host === t.host;
      };
    }() : function () {
      return !0;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7);
    t.exports = n.isStandardBrowserEnv() ? {
      write: function write(t, e, r, o, i, c) {
        var u = [];
        u.push(t + "=" + encodeURIComponent(e)), n.isNumber(r) && u.push("expires=" + new Date(r).toGMTString()), n.isString(o) && u.push("path=" + o), n.isString(i) && u.push("domain=" + i), !0 === c && u.push("secure"), document.cookie = u.join("; ");
      },
      read: function read(t) {
        var e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
        return e ? decodeURIComponent(e[3]) : null;
      },
      remove: function remove(t) {
        this.write(t, "", Date.now() - 864e5);
      }
    } : {
      write: function write() {},
      read: function read() {
        return null;
      },
      remove: function remove() {}
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t, e) {
      return e ? t.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(29);

    function o(t) {
      if ("function" != typeof t) throw new TypeError("executor must be a function.");
      var e;
      this.promise = new Promise(function (t) {
        e = t;
      });
      var r = this;
      t(function (t) {
        r.reason || (r.reason = new n(t), e(r.reason));
      });
    }

    o.prototype.throwIfRequested = function () {
      if (this.reason) throw this.reason;
    }, o.source = function () {
      var t;
      return {
        token: new o(function (e) {
          t = e;
        }),
        cancel: t
      };
    }, t.exports = o;
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t) {
      return function (e) {
        return t.apply(null, e);
      };
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(30),
        o = r(31),
        i = {
      brackets: function brackets(t) {
        return t + "[]";
      },
      indices: function indices(t, e) {
        return t + "[" + e + "]";
      },
      repeat: function repeat(t) {
        return t;
      }
    },
        c = Array.isArray,
        u = Array.prototype.push,
        a = function a(t, e) {
      u.apply(t, c(e) ? e : [e]);
    },
        s = Date.prototype.toISOString,
        f = {
      addQueryPrefix: !1,
      allowDots: !1,
      charset: "utf-8",
      charsetSentinel: !1,
      delimiter: "&",
      encode: !0,
      encoder: n.encode,
      encodeValuesOnly: !1,
      indices: !1,
      serializeDate: function serializeDate(t) {
        return s.call(t);
      },
      skipNulls: !1,
      strictNullHandling: !1
    },
        p = function t(e, r, o, i, c, u, s, p, l, h, d, v, y) {
      var m = e;

      if ("function" == typeof s ? m = s(r, m) : m instanceof Date && (m = h(m)), null === m) {
        if (i) return u && !v ? u(r, f.encoder, y) : r;
        m = "";
      }

      if ("string" == typeof m || "number" == typeof m || "boolean" == typeof m || n.isBuffer(m)) return u ? [d(v ? r : u(r, f.encoder, y)) + "=" + d(u(m, f.encoder, y))] : [d(r) + "=" + d(String(m))];
      var g,
          x = [];
      if (void 0 === m) return x;
      if (Array.isArray(s)) g = s;else {
        var w = Object.keys(m);
        g = p ? w.sort(p) : w;
      }

      for (var b = 0; b < g.length; ++b) {
        var k = g[b];
        c && null === m[k] || (Array.isArray(m) ? a(x, t(m[k], o(r, k), o, i, c, u, s, p, l, h, d, v, y)) : a(x, t(m[k], r + (l ? "." + k : "[" + k + "]"), o, i, c, u, s, p, l, h, d, v, y)));
      }

      return x;
    };

    t.exports = function (t, e) {
      var r = t,
          c = e ? n.assign({}, e) : {};
      if (null !== c.encoder && void 0 !== c.encoder && "function" != typeof c.encoder) throw new TypeError("Encoder has to be a function.");
      var u = void 0 === c.delimiter ? f.delimiter : c.delimiter,
          s = "boolean" == typeof c.strictNullHandling ? c.strictNullHandling : f.strictNullHandling,
          l = "boolean" == typeof c.skipNulls ? c.skipNulls : f.skipNulls,
          h = "boolean" == typeof c.encode ? c.encode : f.encode,
          d = "function" == typeof c.encoder ? c.encoder : f.encoder,
          v = "function" == typeof c.sort ? c.sort : null,
          y = void 0 === c.allowDots ? f.allowDots : !!c.allowDots,
          m = "function" == typeof c.serializeDate ? c.serializeDate : f.serializeDate,
          g = "boolean" == typeof c.encodeValuesOnly ? c.encodeValuesOnly : f.encodeValuesOnly,
          x = c.charset || f.charset;
      if (void 0 !== c.charset && "utf-8" !== c.charset && "iso-8859-1" !== c.charset) throw new Error("The charset option must be either utf-8, iso-8859-1, or undefined");
      if (void 0 === c.format) c.format = o["default"];else if (!Object.prototype.hasOwnProperty.call(o.formatters, c.format)) throw new TypeError("Unknown format option provided.");
      var w,
          b,
          k = o.formatters[c.format];
      "function" == typeof c.filter ? r = (b = c.filter)("", r) : Array.isArray(c.filter) && (w = b = c.filter);
      var R,
          P = [];
      if ("object" != _typeof(r) || null === r) return "";
      R = c.arrayFormat in i ? c.arrayFormat : "indices" in c ? c.indices ? "indices" : "repeat" : "indices";
      var O = i[R];
      w || (w = Object.keys(r)), v && w.sort(v);

      for (var S = 0; S < w.length; ++S) {
        var j = w[S];
        l && null === r[j] || a(P, p(r[j], j, O, s, l, h ? d : null, b, v, y, m, k, g, x));
      }

      var _ = P.join(u),
          E = !0 === c.addQueryPrefix ? "?" : "";

      return c.charsetSentinel && (E += "iso-8859-1" === x ? "utf8=%26%2310003%3B&" : "utf8=%E2%9C%93&"), _.length > 0 ? E + _ : "";
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(30),
        o = Object.prototype.hasOwnProperty,
        i = {
      allowDots: !1,
      allowPrototypes: !1,
      arrayLimit: 20,
      charset: "utf-8",
      charsetSentinel: !1,
      decoder: n.decode,
      delimiter: "&",
      depth: 5,
      ignoreQueryPrefix: !1,
      interpretNumericEntities: !1,
      parameterLimit: 1e3,
      parseArrays: !0,
      plainObjects: !1,
      strictNullHandling: !1
    },
        c = function c(t) {
      return t.replace(/&#(\d+);/g, function (t, e) {
        return String.fromCharCode(parseInt(e, 10));
      });
    },
        u = function u(t, e, r) {
      if (t) {
        var n = r.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t,
            i = /(\[[^[\]]*])/g,
            c = /(\[[^[\]]*])/.exec(n),
            u = c ? n.slice(0, c.index) : n,
            a = [];

        if (u) {
          if (!r.plainObjects && o.call(Object.prototype, u) && !r.allowPrototypes) return;
          a.push(u);
        }

        for (var s = 0; null !== (c = i.exec(n)) && s < r.depth;) {
          if (s += 1, !r.plainObjects && o.call(Object.prototype, c[1].slice(1, -1)) && !r.allowPrototypes) return;
          a.push(c[1]);
        }

        return c && a.push("[" + n.slice(c.index) + "]"), function (t, e, r) {
          for (var n = e, o = t.length - 1; o >= 0; --o) {
            var i,
                c = t[o];
            if ("[]" === c && r.parseArrays) i = [].concat(n);else {
              i = r.plainObjects ? Object.create(null) : {};
              var u = "[" === c.charAt(0) && "]" === c.charAt(c.length - 1) ? c.slice(1, -1) : c,
                  a = parseInt(u, 10);
              r.parseArrays || "" !== u ? !isNaN(a) && c !== u && String(a) === u && a >= 0 && r.parseArrays && a <= r.arrayLimit ? (i = [])[a] = n : i[u] = n : i = {
                0: n
              };
            }
            n = i;
          }

          return n;
        }(a, e, r);
      }
    };

    t.exports = function (t, e) {
      var r = e ? n.assign({}, e) : {};
      if (null !== r.decoder && void 0 !== r.decoder && "function" != typeof r.decoder) throw new TypeError("Decoder has to be a function.");
      if (r.ignoreQueryPrefix = !0 === r.ignoreQueryPrefix, r.delimiter = "string" == typeof r.delimiter || n.isRegExp(r.delimiter) ? r.delimiter : i.delimiter, r.depth = "number" == typeof r.depth ? r.depth : i.depth, r.arrayLimit = "number" == typeof r.arrayLimit ? r.arrayLimit : i.arrayLimit, r.parseArrays = !1 !== r.parseArrays, r.decoder = "function" == typeof r.decoder ? r.decoder : i.decoder, r.allowDots = void 0 === r.allowDots ? i.allowDots : !!r.allowDots, r.plainObjects = "boolean" == typeof r.plainObjects ? r.plainObjects : i.plainObjects, r.allowPrototypes = "boolean" == typeof r.allowPrototypes ? r.allowPrototypes : i.allowPrototypes, r.parameterLimit = "number" == typeof r.parameterLimit ? r.parameterLimit : i.parameterLimit, r.strictNullHandling = "boolean" == typeof r.strictNullHandling ? r.strictNullHandling : i.strictNullHandling, void 0 !== r.charset && "utf-8" !== r.charset && "iso-8859-1" !== r.charset) throw new Error("The charset option must be either utf-8, iso-8859-1, or undefined");
      if (void 0 === r.charset && (r.charset = i.charset), "" === t || null == t) return r.plainObjects ? Object.create(null) : {};

      for (var a = "string" == typeof t ? function (t, e) {
        var r,
            u = {},
            a = e.ignoreQueryPrefix ? t.replace(/^\?/, "") : t,
            s = e.parameterLimit === 1 / 0 ? void 0 : e.parameterLimit,
            f = a.split(e.delimiter, s),
            p = -1,
            l = e.charset;
        if (e.charsetSentinel) for (r = 0; r < f.length; ++r) {
          0 === f[r].indexOf("utf8=") && ("utf8=%E2%9C%93" === f[r] ? l = "utf-8" : "utf8=%26%2310003%3B" === f[r] && (l = "iso-8859-1"), p = r, r = f.length);
        }

        for (r = 0; r < f.length; ++r) {
          if (r !== p) {
            var h,
                d,
                v = f[r],
                y = v.indexOf("]="),
                m = -1 === y ? v.indexOf("=") : y + 1;
            -1 === m ? (h = e.decoder(v, i.decoder, l), d = e.strictNullHandling ? null : "") : (h = e.decoder(v.slice(0, m), i.decoder, l), d = e.decoder(v.slice(m + 1), i.decoder, l)), d && e.interpretNumericEntities && "iso-8859-1" === l && (d = c(d)), o.call(u, h) ? u[h] = n.combine(u[h], d) : u[h] = d;
          }
        }

        return u;
      }(t, r) : t, s = r.plainObjects ? Object.create(null) : {}, f = Object.keys(a), p = 0; p < f.length; ++p) {
        var l = f[p],
            h = u(l, a[l], r);
        s = n.merge(s, h, r);
      }

      return n.compact(s);
    };
  }, function (t, e) {
    t.exports = function (t) {
      return -1 !== Function.toString.call(t).indexOf("[native code]");
    };
  }, function (t, e, r) {
    var n = r(15);

    function o() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    function i(e, r, c) {
      return o() ? t.exports = i = Reflect.construct : t.exports = i = function i(t, e, r) {
        var o = [null];
        o.push.apply(o, e);
        var i = new (Function.bind.apply(t, o))();
        return r && n(i, r.prototype), i;
      }, i.apply(null, arguments);
    }

    t.exports = i;
  }, function (t, e, r) {
    var n = r(63),
        o = r(103);

    t.exports = function (t, e) {
      for (var r = 0, i = (e = n(e, t)).length; null != t && r < i;) {
        t = t[o(e[r++])];
      }

      return r && r == i ? t : void 0;
    };
  }, function (t, e, r) {
    var n = r(16),
        o = r(64),
        i = r(70),
        c = r(100);

    t.exports = function (t, e) {
      return n(t) ? t : o(t, e) ? [t] : i(c(t));
    };
  }, function (t, e, r) {
    var n = r(16),
        o = r(17),
        i = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        c = /^\w*$/;

    t.exports = function (t, e) {
      if (n(t)) return !1;

      var r = _typeof(t);

      return !("number" != r && "symbol" != r && "boolean" != r && null != t && !o(t)) || c.test(t) || !i.test(t) || null != e && t in Object(e);
    };
  }, function (t, e, r) {
    (function (e) {
      var r = "object" == _typeof(e) && e && e.Object === Object && e;
      t.exports = r;
    }).call(this, r(66));
  }, function (t, e) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (t) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (r = window);
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = r(18),
        o = Object.prototype,
        i = o.hasOwnProperty,
        c = o.toString,
        u = n ? n.toStringTag : void 0;

    t.exports = function (t) {
      var e = i.call(t, u),
          r = t[u];

      try {
        t[u] = void 0;
        var n = !0;
      } catch (t) {}

      var o = c.call(t);
      return n && (e ? t[u] = r : delete t[u]), o;
    };
  }, function (t, e) {
    var r = Object.prototype.toString;

    t.exports = function (t) {
      return r.call(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      return null != t && "object" == _typeof(t);
    };
  }, function (t, e, r) {
    var n = r(71),
        o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        i = /\\(\\)?/g,
        c = n(function (t) {
      var e = [];
      return 46 === t.charCodeAt(0) && e.push(""), t.replace(o, function (t, r, n, o) {
        e.push(n ? o.replace(i, "$1") : r || t);
      }), e;
    });
    t.exports = c;
  }, function (t, e, r) {
    var n = r(72);

    t.exports = function (t) {
      var e = n(t, function (t) {
        return 500 === r.size && r.clear(), t;
      }),
          r = e.cache;
      return e;
    };
  }, function (t, e, r) {
    var n = r(73);

    function o(t, e) {
      if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");

      var r = function r() {
        var n = arguments,
            o = e ? e.apply(this, n) : n[0],
            i = r.cache;
        if (i.has(o)) return i.get(o);
        var c = t.apply(this, n);
        return r.cache = i.set(o, c) || i, c;
      };

      return r.cache = new (o.Cache || n)(), r;
    }

    o.Cache = n, t.exports = o;
  }, function (t, e, r) {
    var n = r(74),
        o = r(95),
        i = r(97),
        c = r(98),
        u = r(99);

    function a(t) {
      var e = -1,
          r = null == t ? 0 : t.length;

      for (this.clear(); ++e < r;) {
        var n = t[e];
        this.set(n[0], n[1]);
      }
    }

    a.prototype.clear = n, a.prototype["delete"] = o, a.prototype.get = i, a.prototype.has = c, a.prototype.set = u, t.exports = a;
  }, function (t, e, r) {
    var n = r(75),
        o = r(87),
        i = r(94);

    t.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new n(),
        map: new (i || o)(),
        string: new n()
      };
    };
  }, function (t, e, r) {
    var n = r(76),
        o = r(83),
        i = r(84),
        c = r(85),
        u = r(86);

    function a(t) {
      var e = -1,
          r = null == t ? 0 : t.length;

      for (this.clear(); ++e < r;) {
        var n = t[e];
        this.set(n[0], n[1]);
      }
    }

    a.prototype.clear = n, a.prototype["delete"] = o, a.prototype.get = i, a.prototype.has = c, a.prototype.set = u, t.exports = a;
  }, function (t, e, r) {
    var n = r(12);

    t.exports = function () {
      this.__data__ = n ? n(null) : {}, this.size = 0;
    };
  }, function (t, e, r) {
    var n = r(78),
        o = r(79),
        i = r(34),
        c = r(81),
        u = /^\[object .+?Constructor\]$/,
        a = Function.prototype,
        s = Object.prototype,
        f = a.toString,
        p = s.hasOwnProperty,
        l = RegExp("^" + f.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    t.exports = function (t) {
      return !(!i(t) || o(t)) && (n(t) ? l : u).test(c(t));
    };
  }, function (t, e, r) {
    var n = r(32),
        o = r(34);

    t.exports = function (t) {
      if (!o(t)) return !1;
      var e = n(t);
      return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
    };
  }, function (t, e, r) {
    var n,
        o = r(80),
        i = (n = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "";

    t.exports = function (t) {
      return !!i && i in t;
    };
  }, function (t, e, r) {
    var n = r(19)["__core-js_shared__"];
    t.exports = n;
  }, function (t, e) {
    var r = Function.prototype.toString;

    t.exports = function (t) {
      if (null != t) {
        try {
          return r.call(t);
        } catch (t) {}

        try {
          return t + "";
        } catch (t) {}
      }

      return "";
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return null == t ? void 0 : t[e];
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    };
  }, function (t, e, r) {
    var n = r(12),
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      var e = this.__data__;

      if (n) {
        var r = e[t];
        return "__lodash_hash_undefined__" === r ? void 0 : r;
      }

      return o.call(e, t) ? e[t] : void 0;
    };
  }, function (t, e, r) {
    var n = r(12),
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      var e = this.__data__;
      return n ? void 0 !== e[t] : o.call(e, t);
    };
  }, function (t, e, r) {
    var n = r(12);

    t.exports = function (t, e) {
      var r = this.__data__;
      return this.size += this.has(t) ? 0 : 1, r[t] = n && void 0 === e ? "__lodash_hash_undefined__" : e, this;
    };
  }, function (t, e, r) {
    var n = r(88),
        o = r(89),
        i = r(91),
        c = r(92),
        u = r(93);

    function a(t) {
      var e = -1,
          r = null == t ? 0 : t.length;

      for (this.clear(); ++e < r;) {
        var n = t[e];
        this.set(n[0], n[1]);
      }
    }

    a.prototype.clear = n, a.prototype["delete"] = o, a.prototype.get = i, a.prototype.has = c, a.prototype.set = u, t.exports = a;
  }, function (t, e) {
    t.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (t, e, r) {
    var n = r(13),
        o = Array.prototype.splice;

    t.exports = function (t) {
      var e = this.__data__,
          r = n(e, t);
      return !(r < 0) && (r == e.length - 1 ? e.pop() : o.call(e, r, 1), --this.size, !0);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t === e || t != t && e != e;
    };
  }, function (t, e, r) {
    var n = r(13);

    t.exports = function (t) {
      var e = this.__data__,
          r = n(e, t);
      return r < 0 ? void 0 : e[r][1];
    };
  }, function (t, e, r) {
    var n = r(13);

    t.exports = function (t) {
      return n(this.__data__, t) > -1;
    };
  }, function (t, e, r) {
    var n = r(13);

    t.exports = function (t, e) {
      var r = this.__data__,
          o = n(r, t);
      return o < 0 ? (++this.size, r.push([t, e])) : r[o][1] = e, this;
    };
  }, function (t, e, r) {
    var n = r(33)(r(19), "Map");
    t.exports = n;
  }, function (t, e, r) {
    var n = r(14);

    t.exports = function (t) {
      var e = n(this, t)["delete"](t);
      return this.size -= e ? 1 : 0, e;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = _typeof(t);

      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    };
  }, function (t, e, r) {
    var n = r(14);

    t.exports = function (t) {
      return n(this, t).get(t);
    };
  }, function (t, e, r) {
    var n = r(14);

    t.exports = function (t) {
      return n(this, t).has(t);
    };
  }, function (t, e, r) {
    var n = r(14);

    t.exports = function (t, e) {
      var r = n(this, t),
          o = r.size;
      return r.set(t, e), this.size += r.size == o ? 0 : 1, this;
    };
  }, function (t, e, r) {
    var n = r(101);

    t.exports = function (t) {
      return null == t ? "" : n(t);
    };
  }, function (t, e, r) {
    var n = r(18),
        o = r(102),
        i = r(16),
        c = r(17),
        u = n ? n.prototype : void 0,
        a = u ? u.toString : void 0;

    t.exports = function t(e) {
      if ("string" == typeof e) return e;
      if (i(e)) return o(e, t) + "";
      if (c(e)) return a ? a.call(e) : "";
      var r = e + "";
      return "0" == r && 1 / e == -1 / 0 ? "-0" : r;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var r = -1, n = null == t ? 0 : t.length, o = Array(n); ++r < n;) {
        o[r] = e(t[r], r, t);
      }

      return o;
    };
  }, function (t, e, r) {
    var n = r(17);

    t.exports = function (t) {
      if ("string" == typeof t || n(t)) return t;
      var e = t + "";
      return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
    };
  }, function (t, e, r) {
    "use strict";

    r.r(e);
    var n = {};
    r.r(n), r.d(n, "storefrontPath", function () {
      return g;
    }), r.d(n, "Routes", function () {
      return x;
    });
    var o = {};
    r.r(o), r.d(o, "Account", function () {
      return k;
    }), r.d(o, "Authentication", function () {
      return O;
    }), r.d(o, "Cart", function () {
      return _;
    }), r.d(o, "Checkout", function () {
      return A;
    }), r.d(o, "Countries", function () {
      return D;
    }), r.d(o, "Order", function () {
      return B;
    }), r.d(o, "Products", function () {
      return M;
    }), r.d(o, "Taxons", function () {
      return H;
    });
    var i = r(2),
        c = r.n(i),
        u = r(5),
        a = r.n(u),
        s = r(0),
        f = r.n(s),
        p = r(3),
        l = r.n(p),
        h = r(4),
        d = r.n(h),
        v = r(1),
        y = r.n(v),
        m = r(6),
        g = "api/v2/storefront",
        x = {
      productsPath: function productsPath() {
        return "".concat(g, "/products");
      },
      productPath: function productPath(t) {
        return "".concat(g, "/products/").concat(t);
      },
      taxonsPath: function taxonsPath() {
        return "".concat(g, "/taxons");
      },
      taxonPath: function taxonPath(t) {
        return "".concat(g, "/taxons/").concat(t);
      },
      countriesPath: function countriesPath() {
        return "".concat(g, "/countries");
      },
      countryPath: function countryPath(t) {
        return "".concat(g, "/countries/").concat(t);
      },
      cartPath: function cartPath() {
        return "".concat(g, "/cart");
      },
      cartAddItemPath: function cartAddItemPath() {
        return "".concat(g, "/cart/add_item");
      },
      cartRemoveItemPath: function cartRemoveItemPath(t) {
        return "".concat(g, "/cart/remove_line_item/").concat(t);
      },
      cartEmptyPath: function cartEmptyPath() {
        return "".concat(g, "/cart/empty");
      },
      cartSetItemQuantity: function cartSetItemQuantity() {
        return "".concat(g, "/cart/set_quantity");
      },
      cartApplyCodePath: function cartApplyCodePath() {
        return "".concat(g, "/cart/apply_coupon_code");
      },
      cartRemoveCodePath: function cartRemoveCodePath(t) {
        return "".concat(g, "/cart/remove_coupon_code/").concat(t);
      },
      cartEstimateShippingMethodsPath: function cartEstimateShippingMethodsPath() {
        return "".concat(g, "/cart/estimate_shipping_rates");
      },
      checkoutPath: function checkoutPath() {
        return "".concat(g, "/checkout");
      },
      checkoutNextPath: function checkoutNextPath() {
        return "".concat(g, "/checkout/next");
      },
      checkoutAdvancePath: function checkoutAdvancePath() {
        return "".concat(g, "/checkout/advance");
      },
      checkoutCompletePath: function checkoutCompletePath() {
        return "".concat(g, "/checkout/complete");
      },
      checkoutAddStoreCreditsPath: function checkoutAddStoreCreditsPath() {
        return "".concat(g, "/checkout/add_store_credit");
      },
      checkoutRemoveStoreCreditsPath: function checkoutRemoveStoreCreditsPath() {
        return "".concat(g, "/checkout/remove_store_credit");
      },
      checkoutPaymentMethodsPath: function checkoutPaymentMethodsPath() {
        return "".concat(g, "/checkout/payment_methods");
      },
      checkoutShippingMethodsPath: function checkoutShippingMethodsPath() {
        return "".concat(g, "/checkout/shipping_rates");
      },
      oauthTokenPath: function oauthTokenPath() {
        return "spree_oauth/token";
      },
      accountPath: function accountPath() {
        return "".concat(g, "/account");
      },
      accountCreditCardsPath: function accountCreditCardsPath() {
        return "".concat(g, "/account/credit_cards");
      },
      accountDefaultCreditCardPath: function accountDefaultCreditCardPath() {
        return "".concat(g, "/account/credit_cards/default");
      },
      accountCompletedOrdersPath: function accountCompletedOrdersPath() {
        return "".concat(g, "/account/orders");
      },
      accountCompletedOrderPath: function accountCompletedOrderPath(t) {
        return "".concat(g, "/account/orders/").concat(t);
      },
      orderStatusPath: function orderStatusPath(t) {
        return "".concat(g, "/order_status/").concat(t);
      }
    };

    function w() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var b = function b(t, e, r, n) {
      return new (r || (r = Promise))(function (o, i) {
        function c(t) {
          try {
            a(n.next(t));
          } catch (t) {
            i(t);
          }
        }

        function u(t) {
          try {
            a(n["throw"](t));
          } catch (t) {
            i(t);
          }
        }

        function a(t) {
          t.done ? o(t.value) : new r(function (e) {
            e(t.value);
          }).then(c, u);
        }

        a((n = n.apply(t, e || [])).next());
      });
    },
        k = function (t) {
      l()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = y()(e);

        if (w()) {
          var n = y()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return d()(this, t);
      });

      function n() {
        return c()(this, n), r.apply(this, arguments);
      }

      return a()(n, [{
        key: "accountInfo",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return b(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("get", x.accountPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "creditCardsList",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return b(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("get", x.accountCreditCardsPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "defaultCreditCard",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return b(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("get", x.accountDefaultCreditCardPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "completedOrdersList",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return b(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("get", x.accountCompletedOrdersPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "completedOrder",
        value: function value(t, e) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return b(this, void 0, void 0, f.a.mark(function n() {
            return f.a.wrap(function (n) {
              for (;;) {
                switch (n.prev = n.next) {
                  case 0:
                    return n.next = 2, this.spreeResponse("get", x.accountCompletedOrderPath(e), t, r);

                  case 2:
                    return n.abrupt("return", n.sent);

                  case 3:
                  case "end":
                    return n.stop();
                }
              }
            }, n, this);
          }));
        }
      }]), n;
    }(m.a);

    function R() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var P = function P(t, e, r, n) {
      return new (r || (r = Promise))(function (o, i) {
        function c(t) {
          try {
            a(n.next(t));
          } catch (t) {
            i(t);
          }
        }

        function u(t) {
          try {
            a(n["throw"](t));
          } catch (t) {
            i(t);
          }
        }

        function a(t) {
          t.done ? o(t.value) : new r(function (e) {
            e(t.value);
          }).then(c, u);
        }

        a((n = n.apply(t, e || [])).next());
      });
    },
        O = function (t) {
      l()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = y()(e);

        if (R()) {
          var n = y()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return d()(this, t);
      });

      function n() {
        return c()(this, n), r.apply(this, arguments);
      }

      return a()(n, [{
        key: "getToken",
        value: function value(t) {
          return P(this, void 0, void 0, f.a.mark(function e() {
            return f.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.spreeResponse("post", x.oauthTokenPath(), {}, {
                      username: (r = t).username,
                      password: r.password,
                      grant_type: "password"
                    });

                  case 2:
                    return e.abrupt("return", e.sent);

                  case 3:
                  case "end":
                    return e.stop();
                }
              }

              var r;
            }, e, this);
          }));
        }
      }, {
        key: "refreshToken",
        value: function value(t) {
          return P(this, void 0, void 0, f.a.mark(function e() {
            return f.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.spreeResponse("post", x.oauthTokenPath(), {}, {
                      refresh_token: t.refresh_token,
                      grant_type: "refresh_token"
                    });

                  case 2:
                    return e.abrupt("return", e.sent);

                  case 3:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
        }
      }]), n;
    }(m.a);

    function S() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var j = function j(t, e, r, n) {
      return new (r || (r = Promise))(function (o, i) {
        function c(t) {
          try {
            a(n.next(t));
          } catch (t) {
            i(t);
          }
        }

        function u(t) {
          try {
            a(n["throw"](t));
          } catch (t) {
            i(t);
          }
        }

        function a(t) {
          t.done ? o(t.value) : new r(function (e) {
            e(t.value);
          }).then(c, u);
        }

        a((n = n.apply(t, e || [])).next());
      });
    },
        _ = function (t) {
      l()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = y()(e);

        if (S()) {
          var n = y()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return d()(this, t);
      });

      function n() {
        return c()(this, n), r.apply(this, arguments);
      }

      return a()(n, [{
        key: "show",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return j(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("get", x.cartPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "create",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return j(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("post", x.cartPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "addItem",
        value: function value(t, e) {
          return j(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("post", x.cartAddItemPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "removeItem",
        value: function value(t, e) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return j(this, void 0, void 0, f.a.mark(function n() {
            return f.a.wrap(function (n) {
              for (;;) {
                switch (n.prev = n.next) {
                  case 0:
                    return n.next = 2, this.spreeResponse("delete", x.cartRemoveItemPath(e), t, r);

                  case 2:
                    return n.abrupt("return", n.sent);

                  case 3:
                  case "end":
                    return n.stop();
                }
              }
            }, n, this);
          }));
        }
      }, {
        key: "emptyCart",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return j(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("patch", x.cartEmptyPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "setQuantity",
        value: function value(t, e) {
          return j(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("patch", x.cartSetItemQuantity(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "applyCouponCode",
        value: function value(t, e) {
          return j(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("patch", x.cartApplyCodePath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "removeCouponCode",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return j(this, void 0, void 0, f.a.mark(function n() {
            var o;
            return f.a.wrap(function (n) {
              for (;;) {
                switch (n.prev = n.next) {
                  case 0:
                    return o = "", o = null !== e ? x.cartRemoveCodePath(e) : x.cartRemoveCodePath(""), n.next = 4, this.spreeResponse("delete", o, t, r);

                  case 4:
                    return n.abrupt("return", n.sent);

                  case 5:
                  case "end":
                    return n.stop();
                }
              }
            }, n, this);
          }));
        }
      }, {
        key: "estimateShippingMethods",
        value: function value(t, e) {
          return j(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("get", x.cartEstimateShippingMethodsPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }]), n;
    }(m.a);

    function E() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var C = function C(t, e, r, n) {
      return new (r || (r = Promise))(function (o, i) {
        function c(t) {
          try {
            a(n.next(t));
          } catch (t) {
            i(t);
          }
        }

        function u(t) {
          try {
            a(n["throw"](t));
          } catch (t) {
            i(t);
          }
        }

        function a(t) {
          t.done ? o(t.value) : new r(function (e) {
            e(t.value);
          }).then(c, u);
        }

        a((n = n.apply(t, e || [])).next());
      });
    },
        A = function (t) {
      l()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = y()(e);

        if (E()) {
          var n = y()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return d()(this, t);
      });

      function n() {
        return c()(this, n), r.apply(this, arguments);
      }

      return a()(n, [{
        key: "orderNext",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return C(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("patch", x.checkoutNextPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "orderUpdate",
        value: function value(t, e) {
          return C(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("patch", x.checkoutPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "advance",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return C(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("patch", x.checkoutAdvancePath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "complete",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return C(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("patch", x.checkoutCompletePath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "addStoreCredits",
        value: function value(t, e) {
          return C(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("post", x.checkoutAddStoreCreditsPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "removeStoreCredits",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return C(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("post", x.checkoutRemoveStoreCreditsPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }, {
        key: "paymentMethods",
        value: function value(t) {
          return C(this, void 0, void 0, f.a.mark(function e() {
            return f.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.spreeResponse("get", x.checkoutPaymentMethodsPath(), t);

                  case 2:
                    return e.abrupt("return", e.sent);

                  case 3:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
        }
      }, {
        key: "shippingMethods",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return C(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("get", x.checkoutShippingMethodsPath(), t, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }]), n;
    }(m.a);

    function T() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var L = function L(t, e, r, n) {
      return new (r || (r = Promise))(function (o, i) {
        function c(t) {
          try {
            a(n.next(t));
          } catch (t) {
            i(t);
          }
        }

        function u(t) {
          try {
            a(n["throw"](t));
          } catch (t) {
            i(t);
          }
        }

        function a(t) {
          t.done ? o(t.value) : new r(function (e) {
            e(t.value);
          }).then(c, u);
        }

        a((n = n.apply(t, e || [])).next());
      });
    },
        D = function (t) {
      l()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = y()(e);

        if (T()) {
          var n = y()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return d()(this, t);
      });

      function n() {
        return c()(this, n), r.apply(this, arguments);
      }

      return a()(n, [{
        key: "list",
        value: function value() {
          return L(this, void 0, void 0, f.a.mark(function t() {
            return f.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, this.spreeResponse("get", x.countriesPath());

                  case 2:
                    return t.abrupt("return", t.sent);

                  case 3:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "show",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return L(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("get", x.countryPath(t), {}, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }]), n;
    }(m.a);

    function N() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var F = function F(t, e, r, n) {
      return new (r || (r = Promise))(function (o, i) {
        function c(t) {
          try {
            a(n.next(t));
          } catch (t) {
            i(t);
          }
        }

        function u(t) {
          try {
            a(n["throw"](t));
          } catch (t) {
            i(t);
          }
        }

        function a(t) {
          t.done ? o(t.value) : new r(function (e) {
            e(t.value);
          }).then(c, u);
        }

        a((n = n.apply(t, e || [])).next());
      });
    },
        B = function (t) {
      l()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = y()(e);

        if (N()) {
          var n = y()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return d()(this, t);
      });

      function n() {
        return c()(this, n), r.apply(this, arguments);
      }

      return a()(n, [{
        key: "status",
        value: function value(t, e) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return F(this, void 0, void 0, f.a.mark(function n() {
            return f.a.wrap(function (n) {
              for (;;) {
                switch (n.prev = n.next) {
                  case 0:
                    return n.next = 2, this.spreeResponse("get", x.orderStatusPath(e), t, r);

                  case 2:
                    return n.abrupt("return", n.sent);

                  case 3:
                  case "end":
                    return n.stop();
                }
              }
            }, n, this);
          }));
        }
      }]), n;
    }(m.a);

    function I() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var U = function U(t, e, r, n) {
      return new (r || (r = Promise))(function (o, i) {
        function c(t) {
          try {
            a(n.next(t));
          } catch (t) {
            i(t);
          }
        }

        function u(t) {
          try {
            a(n["throw"](t));
          } catch (t) {
            i(t);
          }
        }

        function a(t) {
          t.done ? o(t.value) : new r(function (e) {
            e(t.value);
          }).then(c, u);
        }

        a((n = n.apply(t, e || [])).next());
      });
    },
        M = function (t) {
      l()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = y()(e);

        if (I()) {
          var n = y()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return d()(this, t);
      });

      function n() {
        return c()(this, n), r.apply(this, arguments);
      }

      return a()(n, [{
        key: "list",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return U(this, void 0, void 0, f.a.mark(function e() {
            return f.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.spreeResponse("get", x.productsPath(), {}, t);

                  case 2:
                    return e.abrupt("return", e.sent);

                  case 3:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
        }
      }, {
        key: "show",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return U(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("get", x.productPath(t), {}, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }]), n;
    }(m.a);

    function z() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    var q = function q(t, e, r, n) {
      return new (r || (r = Promise))(function (o, i) {
        function c(t) {
          try {
            a(n.next(t));
          } catch (t) {
            i(t);
          }
        }

        function u(t) {
          try {
            a(n["throw"](t));
          } catch (t) {
            i(t);
          }
        }

        function a(t) {
          t.done ? o(t.value) : new r(function (e) {
            e(t.value);
          }).then(c, u);
        }

        a((n = n.apply(t, e || [])).next());
      });
    },
        H = function (t) {
      l()(n, t);
      var e,
          r = (e = n, function () {
        var t,
            r = y()(e);

        if (z()) {
          var n = y()(this).constructor;
          t = Reflect.construct(r, arguments, n);
        } else t = r.apply(this, arguments);

        return d()(this, t);
      });

      function n() {
        return c()(this, n), r.apply(this, arguments);
      }

      return a()(n, [{
        key: "list",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return q(this, void 0, void 0, f.a.mark(function e() {
            return f.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.spreeResponse("get", x.taxonsPath(), {}, t);

                  case 2:
                    return e.abrupt("return", e.sent);

                  case 3:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
        }
      }, {
        key: "show",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return q(this, void 0, void 0, f.a.mark(function r() {
            return f.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return r.next = 2, this.spreeResponse("get", x.taxonPath(t), {}, e);

                  case 2:
                    return r.abrupt("return", r.sent);

                  case 3:
                  case "end":
                    return r.stop();
                }
              }
            }, r, this);
          }));
        }
      }]), n;
    }(m.a),
        $ = function () {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        c()(this, t), this.host = e.host || null, this.addEndpoints();
      }

      return a()(t, [{
        key: "addEndpoints",
        value: function value() {
          this.account = this.makeAccount(), this.authentication = this.makeAuthentication(), this.cart = this.makeCart(), this.checkout = this.makeCheckout(), this.countries = this.makeCountries(), this.order = this.makeOrder(), this.products = this.makeProducts(), this.taxons = this.makeTaxons();
        }
      }, {
        key: "makeAccount",
        value: function value() {
          return new k(this.host);
        }
      }, {
        key: "makeAuthentication",
        value: function value() {
          return new O(this.host);
        }
      }, {
        key: "makeCart",
        value: function value() {
          return new _(this.host);
        }
      }, {
        key: "makeCheckout",
        value: function value() {
          return new A(this.host);
        }
      }, {
        key: "makeCountries",
        value: function value() {
          return new D(this.host);
        }
      }, {
        key: "makeOrder",
        value: function value() {
          return new B(this.host);
        }
      }, {
        key: "makeProducts",
        value: function value() {
          return new M(this.host);
        }
      }, {
        key: "makeTaxons",
        value: function value() {
          return new H(this.host);
        }
      }]), t;
    }(),
        G = r(9),
        Q = r(11);

    r.d(e, "makeClient", function () {
      return V;
    }), r.d(e, "Client", function () {
      return $;
    }), r.d(e, "Http", function () {
      return m.a;
    }), r.d(e, "Result", function () {
      return Q.a;
    }), r.d(e, "errors", function () {
      return G;
    }), r.d(e, "endpoints", function () {
      return o;
    }), r.d(e, "routes", function () {
      return n;
    });

    var V = function V() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return new $(t);
    };
  }]);
});